document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('.shopify-policy__container').forEach(el => el.classList.add('page-width'));
});

document.addEventListener("DOMContentLoaded", function () {
    if (
        window.location.pathname === "/" ||
        window.location.pathname === "/index.html"
    ) {
        document.body.classList.add("is-home");
    }
});


const testSwiper = new Swiper('.testimonial-swiper', {
    slidesPerView: 1.2,
    spaceBetween: 10,
    autoplay: {
        delay: 2500,
        disableOnInteraction: false,
    },
    pagination: {
        el: '.swiper-pagination',
        clickable: true,
    },
    navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
    },
    scrollbar: {
        el: '.swiper-scrollbar',
    },
    breakpoints: {
        640: {
            slidesPerView: 2.2,
            spaceBetween: 10,
        },
        768: {
            slidesPerView: 2,
            spaceBetween: 10,
        },
        1024: {
            slidesPerView: 2,
            spaceBetween: 10,
        },
    },
});


const reelSwiper = new Swiper('.reels-area-swipe', {
    slidesPerView: 2.2,
    spaceBetween: 10,
    freeMode: true,
    breakpoints: {
        640: {
            slidesPerView: 2.2,
            spaceBetween: 10,
        },
        768: {
            slidesPerView: 3.5,
            spaceBetween: 10,
        },
        1024: {
            slidesPerView: 5,
            spaceBetween: 10,
        },
    },
});
